import React from 'react';
import BadgeBase, { TBadge } from './BadgeBase';
import { BadgeSignals } from '../../types/TEBadgeSignal';

const Info = (props: Omit<TBadge, 'signal'>) => <BadgeBase {...props} signal={BadgeSignals.Info} />;

export default Info;
